import { useContext, useEffect } from "react";
import FormContext from "./form.context.js";
import useForm from "./use-form.js";
import formListContext from "./form-list.context.js";
export default function useFormField(name, field) {
    const { name: formName } = useContext(FormContext);
    const { inFormList } = useContext(formListContext);
    const form = useForm(formName);
    useEffect(() => {
        form?.linkField?.(name, field, inFormList);
        return () => {
            form?.unlinkField(name, inFormList);
        };
    }, [name, field, inFormList]);
}
